import { Observable } from 'rxjs';
import { CategoryPublicModel } from '../models/category-public.model';

export abstract class CategoryPublicRepository {
    abstract getAll(): Observable<CategoryPublicModel[]>;
}
